export default class BracketGameTiebreakerModel {
  public statTiebreakerEnabled: boolean;
  public statTotal: number;
}
